import React from 'react'
import Logo from '../../components/Logo'
import ReactLogo from '../../components/ReactLogo'
export default function LogoGif() {
  const [runningLogo, setRunningLogo] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => {
      setRunningLogo(true)
    }, 1700)
  }, [])

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'relative' }}>
        <ReactLogo running={runningLogo} />
      </div>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          marginTop: '-100px',
          marginLeft: '-105px',
        }}
      >
        <Logo width={230} height={180} />
      </div>
    </div>
  )
}
